import { OnInit, OnDestroy } from '@angular/core';
import { AdalService } from 'adal-angular4';
import { Router, NavigationEnd, NavigationCancel } from '@angular/router';
import { EnvironmentService } from '../environment-service/environment.service';
import { CountdownService } from '../services/countdown.service';
var ToolbarComponent = /** @class */ (function () {
    // private checkAuthSubscription: Subscription;
    function ToolbarComponent(router, adalService, environmentService, countdownService) {
        this.router = router;
        this.adalService = adalService;
        this.environmentService = environmentService;
        this.countdownService = countdownService;
        this.currentLocation = 'Menu';
    }
    ToolbarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.adalService.handleWindowCallback(false);
        console.log(this.adalService.userInfo);
        // this.checkAuthenticated();
        this.env = this.environmentService.getEnvironmentName().replace(/^\w/, function (c) { return c.toUpperCase(); });
        this.router.events.subscribe(function (val) {
            if (val instanceof NavigationEnd || val instanceof NavigationCancel) {
                //     this.adalService.handleWindowCallback(false);
                // determine current route
                var nextPath_1 = val.urlAfterRedirects;
                if (nextPath_1) {
                    nextPath_1 = nextPath_1.length === 0 ? '' : nextPath_1.substr(1);
                }
                var route = _this.router.config.find(function (f) { return f.path === nextPath_1; });
                if (_this.reloadSubscription) {
                    _this.reloadSubscription.unsubscribe();
                }
                // configure based on route data
                if (route && route.data) {
                    _this.currentLocation = route.data.title || 'Menu';
                    if (route.data.autoReload) {
                        // hard reload every few minutes (as configured) to clear memory leak due to the c3/d3 charts
                        var randomTime = _this.randomIntFromInterval(60 * route.data.autoReload.min, 60 * route.data.autoReload.max);
                        _this.reloadSubscription = _this.countdownService.start('toolbar-reload-page', randomTime).subscribe(function (counter) {
                            if (counter === 0) {
                                window.location.reload(true);
                            }
                        });
                    }
                }
                else {
                    _this.currentLocation = 'Menu';
                }
            }
        });
        var userRoles = this.adalService.userInfo.profile.roles || [];
        this.routes = this.router.config.filter(function (route) {
            return route.data && userRoles.some(function (userRole) {
                return route.data.roles.some(function (role) { return role === userRole; });
            });
        });
    };
    ToolbarComponent.prototype.ngOnDestroy = function () {
        if (this.reloadSubscription) {
            this.reloadSubscription.unsubscribe();
        }
        // if (this.checkAuthSubscription) { this.checkAuthSubscription.unsubscribe(); }
    };
    // private checkAuthenticated() {
    //   if (this.checkAuthSubscription) { this.checkAuthSubscription.unsubscribe(); }
    //   this.checkAuthSubscription = this.countdownService.start('check-auth', 5).subscribe(val => {
    //     this.user = this.adalService.userInfo;
    //     if (val === 0) {
    //       this.adalService.handleWindowCallback(false);
    //       // check authentication
    //       if (this.user.authenticated && document.location.hash === '#/') {
    //         document.location.reload();
    //       } else {
    //         this.checkAuthenticated();
    //       }
    //     }
    //   });
    // }
    ToolbarComponent.prototype.login = function () {
        this.adalService.login();
    };
    ToolbarComponent.prototype.logout = function () {
        this.adalService.logOut();
    };
    Object.defineProperty(ToolbarComponent.prototype, "authenticated", {
        get: function () {
            return this.adalService.userInfo.authenticated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToolbarComponent.prototype, "user", {
        get: function () {
            return this.adalService.userInfo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToolbarComponent.prototype, "displayName", {
        get: function () {
            if (this.authenticated) {
                return this.user.profile.given_name + " " + this.user.profile.family_name;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    ToolbarComponent.prototype.randomIntFromInterval = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    };
    return ToolbarComponent;
}());
export { ToolbarComponent };
